import { withFormik } from "formik"
import * as Yup from "yup"
import NewCuentasBancariasForm from "./form"

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    bic: Yup.string()
      .required(t("errors.fieldEmpty"))
      .test(
        "length",
        t("errors.stringLength", { lengths: "8 u 11" }),
        (value) => {
          return value?.length === 8 || value?.length === 11
        }
      )
      .nullable(),
    cuentaContableEmpresaId: Yup.lazy((value) => {
      if (typeof value === "string") {
        return Yup.string()
      }
      return Yup.object().shape({
        optionValue: Yup.string(),
        optionLabel: Yup.string(),
      })
    }),
    nombre: Yup.string().nullable(),
    entidadBancariaId: Yup.string().required(t("errors.selectedOnePlease")),
    iban: Yup.string()
      .min(15, t("errors.invalidLength"))
      .required(t("errors.fieldEmpty")),
  })

const NewCuentaBancaria = withFormik({
  validateOnChange: true,
  validateOnBlur: true,
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data }) => {
    return {
      id: data?.id || null,
      bic: data?.bic || "",
      cuentaContableEmpresaId: data?.cuentaContableEmpresaId || "",
      entidadBancariaId: data?.entidadBancariaId || "",
      iban: data?.iban || "",
      identificadorAcreedor: data?.identificadores?.acreedor || null,
      identificadorPresentador: data?.identificadores?.presentador || null,
      nombre: data?.nombre || null,
    }
  },
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),
  handleSubmit: async (values, { props }) => {
    const valores = {
      ...values,
      cuentaContableEmpresaId:
        values.cuentaContableEmpresaId.optionValue ||
        values.cuentaContableEmpresaId,
    }
    // @ts-expect-error TS(2339): Property 'createCuentaBancaria' does not exist on ...
    props.createCuentaBancaria(valores)
  },
})(NewCuentasBancariasForm)

export default NewCuentaBancaria
